import {createNavigationContainerRef} from '@react-navigation/native';
import {CommonActions} from '@react-navigation/native';
import {logAttributesForSentryCrashlytics} from '../Utils/fireUtils';
import {dispatchAction} from '../Utils/helpers';
import {setCurrentScreen} from '../Redux/reducers/current_screen.reducer';

export const navigationRefSetter = createNavigationContainerRef();

export function navigate(name, params, caller) {
  console.log_on_production(
    `\x1b[32m\x1b[36m\x1b[4m\x1b[1mNavigation Action - navigate - ${name}\x1b[0m`,
    {
      name,
      params,
      caller,
    },
  );
  if (navigationRefSetter.isReady()) {
    dispatchAction(setCurrentScreen(name));
    navigationRefSetter.navigate(name, params);
  }
}

export function reset(caller) {
  console.log_on_production(
    `\x1b[32m\x1b[36m\x1b[4m\x1b[1mNavigation Action - reset\x1b[0m`,
    {
      caller,
    },
  );
  if (navigationRefSetter.isReady()) {
    CommonActions.reset({
      index: 0, // The active route index in the routes array after the reset
      routes: [
        {name: 'AppLoadingPage'}, // Replace 'InitialScreen' with the name of the screen you want to reset to
      ],
    });
  }
}

// Gets the current screen from navigation state
export const getActiveRouteName = (state) => {
  const route = state.routes[state.index];

  if (route.state) {
    // Dive into nested navigators
    return getActiveRouteName(route.state);
  }

  var params = route?.params || {};
  try {
    if (typeof params == 'object') {
      params = JSON.stringify(params)?.substring(0, 180);
    }
    console.log('getActiveRouteParams', {params});
    logAttributesForSentryCrashlytics?.('getActiveRouteParams', params);
  } catch (paramRouteError) {
    console.log({paramRouteError});
  }

  return route.name;
};

export function goBack(caller) {
  console.log_on_production(
    `\x1b[32m\x1b[36m\x1b[4m\x1b[1mNavigation Action - goBack\x1b[0m`,
    {
      caller,
    },
  );
  if (navigationRefSetter.isReady()) {
    navigationRefSetter.goBack();
  }
}

const closeModal = (modalNameToCheck, caller) => {
  const currentNavState = navigationRefSetter.getState();
  const currentScreen = getActiveRouteName(currentNavState);
  if (currentScreen == modalNameToCheck) {
    console.log('Navigation Action - closeModal - fired', {
      currentScreen,
      modalNameToCheck,
      caller,
    });
    // eslint-disable-next-line no-use-before-define
    navigationRef.goBack();
  } else {
    console.log(
      `\x1b[32m\x1b[36m\x1b[4m\x1b[1mNavigation Action - closeModal - already closed\x1b[0m`,
      {
        currentScreen,
        modalNameToCheck,
        caller,
      },
    );
  }
};

export const navigationRef = {
  navigate,
  navigationRef: navigationRefSetter,
  goBack,
  reset,
  closeModal,
};
